// Components
import { PageHeader } from "../components/PageSpecificComponents";

// Containers
import EditBranchFrom from "../containers/forms/manageBranches/editBranch/EditBranch.form";

// Styles
import { EdtBranchStyles } from "../pagesStyles/editBranch.styles";

const EditBranch = () => {
  return (
    <EdtBranchStyles>
      <PageHeader title="Edit Branch" showBack />
      <EditBranchFrom />
    </EdtBranchStyles>
  );
};

export default EditBranch;
